import React from "react";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
import "./Home.css";
import tomato from "../assets/tomato.jpg";
import lettuce from "../assets/lettuce.jpg";
import redPepper from "../assets/red-pepper.jpg";
import greenPepper from "../assets/green-pepper.jpg";

function Home() {
  const { t } = useTranslation(); // Initialize the translation function

  return (
    <div className="text-center Home">
      <div className="bg-light p-5 rounded-lg text-center">
        <h1>{t('footer_brand')}</h1> {/* Translated brand name */}
        <p className="lead">{t('jumbotron_text')}</p> {/* Translated Jumbotron text */}
      </div>

      <br />

      <div className="gallery">
        <div>
          <img src={tomato} alt={t('tomato')} /> {/* Alt text could also be translated */}
        </div>
        <div>
          <img src={redPepper} alt={t('red_pepper')} /> {/* Example for translatable alt */}
        </div>
        <div>
          <img src={greenPepper} alt={t('green_pepper')} />
        </div>
        <div>
          <img src={lettuce} alt={t('lettuce')} />
        </div>
      </div>
    </div>
  );
}

export default Home;
